<template>
    <div>          
        <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">          
        <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
            <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una plantilla</option>            
            <option 
              :key="TipoPlantilla.TipoPlantillaDeNombramientoId"
              v-for="TipoPlantilla in TiposPlantillasDeNombramientos"
              :value="TipoPlantilla.TipoPlantillaDeNombramientoId">
                {{TipoPlantilla.Nombre}}
              </option>        
        </select>      
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

export default {
  
    data() {
      return {
        enumeraciones,
        comun,
        TiposPlantillasDeNombramientos: [],
        idDelModelo: null        
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      hereda: Number
    },
    mounted() {
      
      //this.params = this.parametros
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_SIAP_Catalogo_Establecer037TipoPlantillaDeNombramiento", params);
    },
    created() {      
       if(this.hereda != undefined){ //para que no truene se deja prop utilizada en otros sistemas, se agrega valor a parametros
          this.parametros.fundamentoLegalId = this.hereda;
       }
        
        this.cargarTiposPlantillasDeNombramientos();
    },
    methods: {
        cargaCatalogo: function (){ 

        },
        cargarTiposPlantillasDeNombramientos: function(){
            
            if(this.parametros == null || this.parametros == undefined)
            this.parametros = {}
            this.parametros.EsPrueba = this.enumeraciones.EsPrueba

            axios.post(api.conexion + api.SIAP.catalogos.C037TiposPlantillasDeNombramientos, this.parametros)
            .then(respuesta => {
                if (respuesta.data.SiHayError) {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {                  
                this.TiposPlantillasDeNombramientos = respuesta.data.TiposPlantillasDeNombramientos;
                console.log(this.TiposPlantillasDeNombramientos);
                
                // if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                //     this.TiposPlantillasDeNombramientos = respuesta.data.GetTiposPlantillasDeNombramientos.filter(cond => this.parametros.filtros.some(incidencia => incidencia == cond.TipoIncidenciaId));
                // }
                }
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
            });
        },
        cambiarDatos(evento) {
            this.idDelModelo = evento.target.value;
            const params = {
            llave: this.idDelInput,
            valor: evento.target.value
            }
            
            this.$store.dispatch("A_SIAP_Catalogo_Establecer033TipoIncidencias", params);
            this.$emit("valorParaElPadre", evento);        
        }
    }
    // created() {
    //   this.cargarTiposPlantillasDeNombramientos();
    // }
}
</script>


// WEBPACK FOOTER //
// src/components/SIAP/Comun/Catalogos/037TiposPlantillasDeNombramientos.vue